import classnames from "classnames"

import styles from "./SelectField.module.css"

const style: { [key: string]: string } = {
  "--icon-image": `url('${process.env.PUBLIC_URL}/images/icons/expand_more.svg')`,
}

type SelectFieldProps = {
  children?: any
  name?: any
  value?: any
  disabled?: boolean
  required?: boolean
  defaultValue?: any
  className?: string
  onChange?: any
  testId?: string
}

const SelectField = ({
  children,
  name,
  value,
  disabled,
  required,
  defaultValue,
  className,
  onChange,
  testId,
}: SelectFieldProps) => {
  const handleChange = (event: any) => {
    if (typeof onChange === "function") {
      onChange(event.target.value)
    }
  }

  return (
    <select
      data-testid={testId}
      className={classnames(styles.field, className)}
      style={style}
      name={name}
      value={value}
      disabled={disabled}
      required={required}
      defaultValue={defaultValue}
      onChange={handleChange}>
      {children}
    </select>
  )
}

export default SelectField
